export default __webpack_public_path__ + "static/media/right-checkmark-removebg-preview.88824f2f.png";